import CardWrap from '../pages/_shared/CardWrap/CardWrap'
import { LoadingOutlined } from '@ant-design/icons'
import { FormattedMessage, useIntl } from 'react-intl'

import styles from '../pages/Studios/Studios.module.scss'

export const Loader = ({ value }: { value?: string }) => {
	return (
		<CardWrap>
			<div className={styles.main_loading + ' ' + styles.active}>
				<div className='row'>
					<div className='col-12'>
						<div className={styles.container}>
							<LoadingOutlined spin className='fs-2 mb-2' />
							{value && <FormattedMessage id={value} />}
						</div>
					</div>
				</div>
			</div>
		</CardWrap>
	)
}
